import styles from "./aboutUs.module.css";
import Teamsection from "../../components/team/teamsection";
import Aboutsection
 from "../../components/AboutTED/Aboutsection";
const AboutUs = () => {
    return (
        <div>
            <Aboutsection />
            <Teamsection></Teamsection>
        </div>
    );
}
 
export default AboutUs;